"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_POINTS_BN = exports.ONE_BN = exports.ZERO_BN = void 0;
const constants_1 = require("../constants");
const anchor_1 = require("@coral-xyz/anchor");
exports.ZERO_BN = new anchor_1.BN(0);
exports.ONE_BN = new anchor_1.BN(1);
exports.BASE_POINTS_BN = new anchor_1.BN(constants_1.BASE_POINTS);
